import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'empathy-viewer-button',
  templateUrl: 'button.component.html',
  styleUrls: ['./button.component.scss']
})
export class EmpathyViewerButtonComponent {
  @Input() color: 'primary' | 'accent' | 'warn' | 'alert' | 'light' | 'success' = 'primary';
  @Input() background: 'transparent' | 'initial' = 'initial';
  @Input() disabled = false;
  @Input() icon: IconDefinition;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() loading = false;
  @Input() loadingText: string;
  @Input() text: string;
  @Input() tooltip: string;

  @Output() clicked = new EventEmitter<void>();
}
